<template>
<div class="media-queries"></div>
</template>

<script>
export default {
    name: 'MediaQueries'
}
</script>

<style lang="scss">

</style>